<template>
    <div class="xs-tabbar" :class="{hidden: active < -1}">
        <van-tabbar :fixed="false" v-model="index" :z-index="9" @change="$emit('change', $event)">
            <van-tabbar-item v-for="(tab, i) in tabs" :key="tab.path" class="r-eid-navHome" :to="tab.path">            
            <span>{{tab.text}}</span>
            <img
                slot="icon"
                slot-scope="props"
                :src="props.active ? icons[i].active : icons[i].normal"
            >
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import {
        mapActions
    } from 'vuex'
    import icon_yazhangdie_active  from '../../assets/img/icon_yazhangdie_active.png'
    import icon_yazhangdie_normal  from '../../assets/img/icon_yazhangdie_normal.png'
    import icon_zhanji_active      from '../../assets/img/icon_zhanji_active.png'
    import icon_zhanji_normal      from '../../assets/img/icon_zhanji_normal.png'
    import icon_paihangbang_active from '../../assets/img/icon_paihangbang_active.png'
    import icon_paihangbang_normal from '../../assets/img/icon_paihangbang_normal.png'
    export default {
        name: 'xs-tabbar',
        props: ['tabs', 'active'],
        data() {
            return {
                index: 0,
                icons : [
                    {active : icon_yazhangdie_active, normal : icon_yazhangdie_normal},
                    {active : icon_zhanji_active, normal : icon_zhanji_normal},
                    {active : icon_paihangbang_active, normal : icon_paihangbang_normal},
                ]
            }
        },
        methods: {
            ...mapActions('nav', ['change'])
        },
        watch: {
            active(active) {
                this.index = active
            },
            $route(route) {
                this.change(route)
            }
        },
        created() {
            this.change(this.$route)
        }
    }

</script>
<style lang="less" scoped>
    .van-tabbar-item__icon img {
        height: 0.48rem;
    }
</style>
